import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=794a169a"
import script from "./LockIcon.vue?vue&type=script&lang=ts"
export * from "./LockIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports